import { successColor } from "assets/jss/material-dashboard-pro-react.js";

export default {
	wrapper: {
		position: 'relative',
		minHeight: '70vh',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#aaa',
		fontSize: '18px',
	},
	loadingIndicatorWrapper: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
	licensingTable: {
		marginTop: '20px',
	},
	noResultsFound: {
		flex: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#aaa',
		fontSize: '14px',
		minHeight: '50vh',
	},
	checkBoxActive: {
		'& span': {
			color: successColor[0],
		},
	},
};
